import { Button } from '../Button';
import { t } from '../i18n/i18n';
import {
  CartAddressFromAddressBookFormHelper,
  CartAddressFromAddressBookFormProps,
} from './CartAddressFromAddressBookForm';
import { Radio } from './fields/RadioCheck';
import { FormGroup } from './FormGroup';
import { InvoiceFieldset } from './InvoiceFieldset';
import { validateExistingAddress } from './useAddressForm';

export const CartAddressFromAddressBookFormA = (props: CartAddressFromAddressBookFormProps) => (
  <CartAddressFromAddressBookFormHelper {...props}>
    {({ fieldsHelper }) => (
      <>
        <FormGroup {...fieldsHelper.addresses.formGroup} label={undefined}>
          {fieldsHelper.addresses.formFields.map(({ address, editAddressButton, radio }) => {
            const validation = validateExistingAddress(address);
            const hasErrors = !validation.isValid;
            const errorId = `address-error-${address.id}`;
            return (
              <div className="mb-2" key={address.id}>
                <Radio {...radio} aria-describedby={hasErrors ? errorId : undefined} />
                <div className="ps-4 mt-n2">
                  <Button
                    {...editAddressButton}
                    className="btn-sm pe-3 fw-light text-decoration-underline text-dark"
                    variant="blank"
                  />
                  {hasErrors && (
                    <small aria-live="polite" id={errorId} role="alert">
                      {t('yup.mixed.addreesIncomplete')}
                    </small>
                  )}
                </div>
              </div>
            );
          })}
        </FormGroup>

        <div className="mb-3">
          <Button
            {...fieldsHelper.buttons.newAddress}
            alignWithFlex
            className="text-decoration-none px-0"
            iconStart={{ name: 'plus', size: 16 }}
            variant="link"
          />
        </div>

        {fieldsHelper.invoice && <InvoiceFieldset invoiceFieldsHelper={fieldsHelper.invoice} />}

        {fieldsHelper.buttons.submit && (
          <Button {...fieldsHelper.buttons.submit} iconEnd={undefined} iconStart={undefined} variant={'primary'} />
        )}
      </>
    )}
  </CartAddressFromAddressBookFormHelper>
);
